import { N05_04 } from "./N05_04";

export const N05_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Agent Name",
                columnName: "TERName",
                width: "300px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "300px",
                align: "left",
                sortable: true,
                sum: false,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "300px",
                align: "center",
                sortable: true,
                sum: false,
              },
            ],
            title: "TerritoryName",
            endpoint: "N05.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N05_04,
            },
          },
        },
      },
    },
  ],
};
